import { render } from "./RulesOfProcedure.vue?vue&type=template&id=393b8ca1&scoped=true"
import script from "./RulesOfProcedure.vue?vue&type=script&lang=js"
export * from "./RulesOfProcedure.vue?vue&type=script&lang=js"

import "./RulesOfProcedure.vue?vue&type=style&index=0&id=393b8ca1&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393b8ca1"]])

export default __exports__